import { render, staticRenderFns } from "./VyAddBtn.vue?vue&type=template&id=68ae4cb5&scoped=true&"
import script from "./VyAddBtn.vue?vue&type=script&lang=js&"
export * from "./VyAddBtn.vue?vue&type=script&lang=js&"
import style0 from "./VyAddBtn.vue?vue&type=style&index=0&id=68ae4cb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae4cb5",
  null
  
)

export default component.exports